
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import { onMounted, computed, SetupContext, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { PasswordResetForm } from '@/types/PasswordResetForm'
import { applyValidation } from '@/utils/validation'
import axios from 'axios'
import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'ResetNewPassword',

  props: {
    hideHeading: {
      type: Boolean,
      default: false
    },
    redirect: {
      type: String,
      default: ''
    }
  },

  components: {
    HeadingLv2,
    FormInputField,
    Alert,
    Button
    // TextLink
  },

  setup(props: any, context: SetupContext) {
    const store = useStore()
    const router = useRouter()

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    const user = reactive<PasswordResetForm>({
      password: '',
      password_confirmation: ''
    })

    const state = reactive<{
      alertMessage: string
      q: string
      token: string
      email: string
    }>({
      alertMessage: '',
      q: '',
      token: '',
      email: ''
    })

    interface ValidationsObject {
      [key: string]: any
    }

    const validations: ValidationsObject = reactive({
      password: {
        rules: ['required', 'password'],
        isError: false,
        errorMessage: ''
      },
      password_confirmation: {
        rules: ['required', 'matchPassword'],
        isError: false,
        errorMessage: ''
      }
    })

    const validation = reactive({
      errors: {}
    })

    const checkConfirmField = (obj: Record<string, string>, value: string) => {
      const rules = validations[obj.name].rules

      const arr: Array<string> = []

      for (let i = 0; i < rules.length; i++) {
        if (rules[i] === 'matchPassword') {
          arr.push('matchPassword:' + obj.target)
        } else {
          arr.push(rules[i])
        }
      }

      const result = applyValidation(arr, value)

      validations[obj.name].isError = result.isError
      validations[obj.name].errorMessage = result.message

      //changeMessage(obj.name, value)
      user[obj.name] = value
    }

    const changeMessage = (name: string, value: string) => {
      user[name] = value

      console.log(name, value)
      const result = applyValidation(validations[name].rules, value)
      console.log('result', result)
      validations[name].isError = result.isError
      validations[name].errorMessage = result.message

      if (name === 'password' && user.password_confirmation) {
        checkConfirmField(
          {
            name: 'password_confirmation',
            target: user.password
          },
          user.password_confirmation
        )
      }
    }

    const reset = () => {
      const form: any = document.querySelector('.reset_form')

      const params: any = {
        password: user.password,
        password_confirmation: user.password_confirmation,
        email: state.email,
        _token: csrf.value,
        token: state.token
      }

      const ajax = axiosSetting('app', 'action')
      ajax
        .post('/password/reset', params)
        .then((res) => {
          store.commit('setPasswordResetToken', true)
          router.push({
            path: `/password/Complete`
          })
        })
        .catch((errors: any) => {
          if (errors.response.data) {
            const errorInfo = errors.response.data
            Object.keys(errorInfo).forEach((key) => {
              // リダイレクト（パスワードが空の場合)
              if (key == 'redirect') {
                // TODO: メッセージ追加
                // リダイレクトする
                router.push(errorInfo[key])
              } else if (key == 'alert') {
                alert(errorInfo[key])
              }

              if (validations[key]) {
                validations[key].isError = true
                validations[key].errorMessage = errorInfo[key]
              }
            })
          }
        })

      return false
    }

    onMounted(async () => {
      const params = new URLSearchParams(location.search)
      const token = params.get('token')
      if (token) {
        state.token = token
      }

      const email = params.get('email')
      if (email) {
        state.email = email
      }

      const q = params.get('q')
      if (q) {
        state.q = q
      }
      if (props.redirect) {
        state.q = props.redirect
      }

      try {
        await axios.post(`/api/checkPasswordTokenExpire`, {
          token: state.token,
          email: state.email,
          _token: csrf
        })
      } catch (e) {
        alert(
          '不正なトークンです。再度メールに記載されたURLから再設定をお願いします。'
        )
        router.push('/password')
      }
    })

    const registerPath = computed(() => {
      const base = '/register/user_category'
      return state.q ? `${base}?q=${state.q}` : base
    })

    // 確認ボタンの活性・非活性制御
    const isDisabledNextBtn = computed(() => {
      if (user.password === '' || user.password_confirmation === '') {
        return true
      }

      const arr: Array<string> = Object.keys(validations)

      for (let i = 0; i < arr.length; i++) {
        if (validations[arr[i]].isError) return true
      }

      return false
    })

    return {
      csrf,
      changeMessage,
      validation,
      validations,
      checkConfirmField,
      state,
      user,
      reset,
      registerPath,
      isDisabledNextBtn
    }
  }
}
